import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21 9.775h-3c-.6 0-1 .391-1 .978s.4.978 1 .978h1.9c-.5 4.105-3.8 7.331-7.9 7.723V7.723c1.7-.391 3-1.956 3-3.813C15 1.76 13.2 0 11 0S7 1.76 7 3.91c0 1.857 1.3 3.324 3 3.813v11.828c-4.2-.488-7.5-3.715-7.9-7.723H4c.6 0 1-.39 1-.977s-.4-.978-1-.978H1c-.6 0-1 .391-1 .978 0 5.962 4.9 10.752 11 10.752s11-4.79 11-10.753c0-.684-.4-1.075-1-1.075M9 3.91c0-1.075.9-1.955 2-1.955s2 .88 2 1.955-.9 1.955-2 1.955-2-.88-2-1.955"
    }, null, -1)
  ]))]))
}
export default { render: render }